module.exports = __webpack_public_path__ + "img/87.8a269c59.jpg";